import { useAccountRepository, useBrandingRepository } from '@frontend/repository';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ConfigurationLink, ConfigurationSection } from '../configuration/configuration-navigation.config';

export const getConfigurationSectionKey = (section: ConfigurationSection) => section.buttons.map((button) => button.to).join('|');

export const useAdminNavbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { currentAccount } = useAccountRepository();
    const { logo_navbar_expanded } = useBrandingRepository();
    const [openSections, setOpenSections] = useState<Set<string>>(() => new Set());

    const toggleSection = (section: ConfigurationSection) => {
        const sectionKey = getConfigurationSectionKey(section);

        setOpenSections((current) => {
            const next = new Set(current);
            if (next.has(sectionKey)) {
                next.delete(sectionKey);
            } else {
                next.add(sectionKey);
            }
            return next;
        });
    };

    const isLinkActive = (link: ConfigurationLink) => location.pathname === link.to || location.pathname.startsWith(`${link.to}/`);

    return {
        currentAccount,
        logo: logo_navbar_expanded,
        navigate,
        openSections,
        toggleSection,
        isLinkActive,
        isSectionOpen: (section: ConfigurationSection) => openSections.has(getConfigurationSectionKey(section)),
        isSectionActive: (section: ConfigurationSection) => section.buttons.some(isLinkActive)
    };
};
